export default "__VITE_ASSET__Kf3unYCP__"